import { ImisResponseItems, PanelDefinitionItem } from "../models/imis.models";
import { PopupOpenCallback } from "../models/popup.models";
import { PopupUtility } from "./popup.utility";
import { RestUtility } from "./rest.utility";
import { UrlUtility } from "./url.utility";

export class PanelsUtility {
    public static getAllPanelDefinitions(): Promise<ImisResponseItems<PanelDefinitionItem>> {
        return RestUtility.restApiGetDataAll<PanelDefinitionItem>("/api/paneldefinition");
    }

    public static async getPanelDefinition(panelId: string, rawResponse?: boolean): Promise<PanelDefinitionItem> {
        let panelDefinitionItem: PanelDefinitionItem;

        try {
            panelDefinitionItem = await RestUtility.restApiGetData<PanelDefinitionItem>(`/api/paneldefinition/${panelId}`, null, rawResponse);
        } catch (error) {
            panelDefinitionItem = null;
        }

        return panelDefinitionItem;
    }
    
    // TODO: this needs refactoring!
    public static addPanelEditorPopupOpen(callback: (sender: Telerik.Web.UI.RadWindow, iframe: HTMLIFrameElement, panelProperties) => void): PopupOpenCallback {
        let getPanelEditorFields = function (iframeContentWindow: Window = window) {
            let sourceFields = [];

            let allLabelOrReadOnlyFieldSelectors = ".PanelField label[for], .PanelFieldValue > span[id]:first-child";
            let jFields = iframeContentWindow.jQuery(allLabelOrReadOnlyFieldSelectors);

            let panelFieldValueChildSelector = ".PanelFieldValue > :first-child";
            let jFieldIds = iframeContentWindow.jQuery(panelFieldValueChildSelector);

            // get field properties
            jFields.each(function (index) {
                let jField = jQuery(this);
                let forAttrValue = jField.attr("for");
                let fieldProperties = {
                    type: "EDIT",
                    tableName: null,
                    fieldName: null,
                    fieldSelector: forAttrValue != null ? "#" + forAttrValue : null
                };

                // readonly fields will be caught using the ID selector rather than a label tag with a FOR attribute
                let fieldId = forAttrValue;
                let idAttrValue = jField.attr("id");
                if (idAttrValue != null) {
                    fieldProperties.type = "READONLY";
                    fieldId = idAttrValue;
                }

                // ensure the selected field id matches that from the fieldId selector, prioritize fieldId value if it exists
                let fieldIdElement = jFieldIds[index];
                let fieldIdElementId = fieldIdElement.id;
                if (fieldIdElementId.length > 0 && fieldIdElementId != fieldId) {
                    fieldId = fieldIdElementId;
                }

                // parse the field id to extract information using a common format
                let searchRegex = /_PanelFieldEditor_(.+?)(___|\.)(.+?)$/;
                let match = fieldId.match(searchRegex);
                if (match.length == 4) {
                    // this is a valid match because it has all the expected capture groups (3 of them)
                    fieldProperties.tableName = match[1];
                    fieldProperties.fieldName = match[3];
                }

                sourceFields.push(fieldProperties);
            });

            return sourceFields;
        };
        let groupPanelEditorFields = function (sourceFields) {
            let sources = {};

            sourceFields.forEach(function (field) {
                let tableName = field.tableName;
                sources[tableName] = Object.assign({
                    tableName: tableName,
                    fields: []
                }, sources[tableName]);

                sources[tableName].fields.push(field);
            });

            return sources;
        };

        let popUpOpenCallbackRef = PopupUtility.addPopupWindowFrameLoad(function (sender, iframe) {
            // ensure url is of a panel editor page
            let iframeSrc = iframe.src;
            if (iframeSrc.indexOf("/PanelEditDialog.aspx") != -1) {
                const MODE = { CREATE: "CREATE", EDIT: "EDIT" };

                let iframeContentWindow = iframe.contentWindow;
                let VAIMISUtilityV2ContentWindow = iframeContentWindow.VAIMISUtilityV2;
                let panelDefinitionId = VAIMISUtilityV2ContentWindow.Url.findUrlParameter("PanelDefinitionId");
                let key = VAIMISUtilityV2ContentWindow.Url.findUrlParameter("iKey");

                // parse key field to extract ID/SEQN properties if any
                let mode = key == "-1" ? MODE.CREATE : MODE.EDIT;
                let identity = [];
                if (mode == MODE.EDIT) {
                    // get id/seqn values
                    let keyParts = key.slice(1).split("|");
                    identity = keyParts;
                }

                // get all sources and fields, organize fields by their sources
                let panelEditorFields = getPanelEditorFields(iframeContentWindow);
                let panelEditorFieldsObject = groupPanelEditorFields(panelEditorFields);
                let sourceFields = Object.keys(panelEditorFieldsObject).map(function (key) { return panelEditorFieldsObject[key]; });

                let panelProperties = { panelDefinitionId: panelDefinitionId, mode: mode, identity: identity, sourceFields: sourceFields };
                callback(sender, iframe, panelProperties);
            }
        });

        return popUpOpenCallbackRef;
    }
}